import { useParams } from 'react-router-dom';
import apiCall from 'apps/wealth/apiCalls/programs';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/AdminCRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './Form';

export const WealthProgramListPage = (props: any) => (
  <ListPage
    title="Wealth Programs"
    apiCall={apiCall}
    columnGenerator={columnsGenerator}
    resourceName="data"
    createUrl="/wealth/programs/create"
    enableSearch={false}
    {...props}
  />
);

export const WealthProgramCreatePage = (props: any) => (
  <CreatePage
    title="Wealth Program"
    apiCall={apiCall}
    listUrl="/wealth/programs"
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);

export const WealthProgramDetailPage = (props: any) => (
  <DetailPage
    title="Wealth Program"
    apiCall={apiCall}
    listUrl="/wealth/programs"
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ editEnabled: false }}
    {...props}
  />
);

export const WealthProgramEditPage = (props: any) => {
  const { id } = useParams();
  return (
    <EditPage
      title="Wealth Program"
      apiCall={apiCall}
      listUrl={`/wealth/programs/${id}`}
      ItemForm={ItemForm}
      options={{ title: 'Edit Program' }}
      resourceName="data"
      {...props}
    />
  );
};
